import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';

type VenueCountryCodeResponse = {
  countryCode: string;
};

type VenueCountryCodeOptions = Omit<
  UseQueryOptions<
    VenueCountryCodeResponse,
    AxiosError,
    VenueCountryCodeResponse,
    (QUERY_KEY | string)[]
  >,
  'queryKey' | 'queryFn' | 'initialData'
>;

export const useQueryGetVenueCountryCode = (
  serialNumberOrImei: string,
  options?: VenueCountryCodeOptions,
) => {
  const enabled = !!serialNumberOrImei && (options?.enabled ?? true);

  return useQuery(
    [QUERY_KEY.GET_STATION_VENUE_COUNTRY_CODE, serialNumberOrImei],
    () =>
      getRequest<VenueCountryCodeResponse>({
        path: 'api/station/venue-country-code',
        config: {
          params: {
            serialNumberOrImei: serialNumberOrImei,
          },
        },
        ignoreAuthHeader: true,
      }),
    {
      staleTime: 1000 * 60 * 10,
      ...options,
      enabled,
    },
  );
};
